import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-700 uppercase">
              <i className="ri-question-line"></i> FAQ
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于资源更新、清晰度选择、下载方式与播放技巧的高频问题，都整理在这里。
              如果没有找到答案，可以重新阅读上方的下载与播放指南。
            </p>
            <div className="mt-6 p-4 rounded-lg border border-background-300 bg-background-50">
              <p className="text-xs leading-relaxed text-foreground-600">
                <span className="font-semibold text-foreground-900">小贴士：</span>
                本页的搜索与筛选只在当前页面内生效，不会上传或保存任何个人数据，安心浏览即可。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-3">
            {faqs.map((item, i) => {
              const isOpen = openIndex === i;
              return (
                <div key={item.q} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? null : i)}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="flex items-center gap-3">
                        <span className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'}`}>
                          {i + 1}
                        </span>
                        <span className="text-sm font-medium text-foreground-900">{item.q}</span>
                      </span>
                      <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-xl text-primary-600 shrink-0`}></i>
                    </button>
                  </h3>
                  <div className={`px-5 pb-5 pl-14 overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}